export const mobile = {
  0: {
    data: 'Projeniz için size teklif verebilmemiz için ihtiyaclarınıza göre  soruları cevaplayınız',
    datalang: 'offerdescription',
    selectable: false,
    selectOK: 1,
    img: '/project/startup.jpg',
  },

  1: {
    data: 'Listedeki test türlerinin hangilerini kullanıyorsunuz ?',
    datalang: 'useplatform',
    selectable: false,
    selectOK: 2,
    selectListData: {
      UnitTest: {
        price: 100,
        image: 'bloetoot.jpg',
        description: 'You can use Bluetooth to communicate and transfer data  between devices.',
        descriptionlang: 'featurebluetooth',
      },
      UITest: {
        price: 200,
        image: 'bloetoot.jpg',
        description: 'A gyroscope is a device that uses Earth’s gravity to help determine orientation.',
        descriptionlang: 'featuregyroscope',
      },
      BDD: {
        price: 300,
        image: 'bloetoot.jpg',
        description: 'An accelerometer is a compact device designed to measure non-gravitational acceleration.',
        descriptionlang: 'featureaccelerometer',
      },
      UAT: {
        price: 100,
        image: 'bloetoot.jpg',
        description: 'Take photos , read QR code or upload images from the camera roll.',
        descriptionlang: 'featurecamera',
      },
    },
    selectPositivePrice: 900,
    selectNegativePrice: 800,

    img: '/project/sensors.jpg',
  },
  2: {
    data: 'Test ve prod ortamınıza yüklenecek binary  geliştiriciler üretiliyormu ?',
    datalang: 'needios',
    selectable: true,
    selectPositive: 4,
    selectNegative: 3,
    selectPositivePrice: 300,
    selectNegativePrice: 200,
    img: '/project/ios.jpg',
  },

  3: {
    data: 'Tüm deployment süreci otomatik mi ?',
    datalang: 'needlogin',
    selectable: true,
    selectPositive: 4,
    selectNegative: 4,
    selectPositivePrice: 700,
    selectNegativePrice: 400,

    img: '/project/login.jpg',
  },
  4: {
    data: 'Android Web platformunda uygumalamalarınız  varmı ?',
    datalang: 'needsociallogin',
    selectable: true,
    selectPositive: 5,
    selectNegative: 5,
    selectPositivePrice: 600,
    selectNegativePrice: 700,

    img: '/project/login.jpg',
  },
  5: {
    data: 'Uygulamanızda Profil sayfasına ihtiyacınız varmı ?',
    datalang: 'needprofile',
    selectable: true,
    selectPositive: 6,
    selectNegative: 6,
    selectPositivePrice: 700,
    selectNegativePrice: 400,
    img: '/project/profile.jpg',
  },
  6: {
    data: 'ihtiyacınız olan sensorleri seçiniz ?',
    datalang: 'needsensors',
    selectable: false,
    selectOK: 8,
    selectListData: {
      Bluetooth: {
        price: 100,
        image: 'bloetoot.jpg',
        description: 'You can use Bluetooth to communicate and transfer data  between devices.',
        descriptionlang: 'featurebluetooth',
      },
      Gyroscope: {
        price: 200,
        image: 'bloetoot.jpg',
        description: 'A gyroscope is a device that uses Earth’s gravity to help determine orientation.',
        descriptionlang: 'featuregyroscope',
      },
      Accelerometer: {
        price: 300,
        image: 'bloetoot.jpg',
        description: 'An accelerometer is a compact device designed to measure non-gravitational acceleration.',
        descriptionlang: 'featureaccelerometer',
      },
      Camera: {
        price: 100,
        image: 'bloetoot.jpg',
        description: 'Take photos , read QR code or upload images from the camera roll.',
        descriptionlang: 'featurecamera',
      },
    },
    selectPositivePrice: 900,
    selectNegativePrice: 800,

    img: '/project/sensors.jpg',
  },
  8: {
    data: 'Uygulamanızda ürün satacakmısınız ?',
    datalang: 'needsell',
    selectable: true,
    selectPositivePrice: 900,
    selectNegativePrice: 800,
    selectPositive: 9,
    selectNegative: 9,
    selectOK: 100,
    img: '/project/mobilemoney.jpg',
  },
  9: {
    data: 'Harita ve gps  kullanacakmısınız ?',
    datalang: 'needgpsmap',
    selectable: true,
    selectPositive: 10,
    selectNegative: 10,
    selectPositivePrice: 1100,
    selectNegativePrice: 1000,

    img: '/project/maps.jpg',
  },
  10: {
    data: 'Müsterişerinize veya müşterilerinizden size ses vaya video  aktarılacakmı ?',
    datalang: 'needstream',
    selectable: true,
    selectPositive: 11,
    selectNegative: 11,
    selectPositivePrice: 1100,
    selectNegativePrice: 1000,

    img: '/project/uploadstream.jpg',
  },
  11: {
    data: 'Uygulamanız ücretlimi olacak ?',
    datalang: 'needfree',
    selectable: true,
    selectPositive: 12,
    selectNegative: 14,
    selectPositivePrice: 1100,
    selectNegativePrice: 1000,

    img: '/project/mobilemoney.jpg',
  },
  12: {
    data: 'Aylık abonelik olacakmı ?',
    datalang: 'needsubsicription',
    selectable: true,
    selectPositive: 14,
    selectNegative: 13,
    selectPositivePrice: 1100,
    selectNegativePrice: 1000,

    img: '/project/mobilemoney.jpg',
  },
  13: {
    data: 'Uygulama içi satış olacakmı ?',
    datalang: 'needsellItem',
    selectable: true,
    selectPositive: 14,
    selectNegative: 14,
    selectPositivePrice: 1100,
    selectNegativePrice: 1000,

    img: '/project/mobilemoney.jpg',
  },

  14: {
    data: 'Web arayüzüne ihtiyacınız varmı ?',
    datalang: 'needweb',
    selectable: true,
    selectPositive: 15,
    selectNegative: 15,
    selectPositivePrice: 15,
    selectNegativePrice: 15,

    img: '/project/webui.jpg',
  },

  15: {
    data: 'Size iletilen teklif ve proje planından sonra eğer  uygun bulursanız detaylarınızı ',
    datalang: 'needfinish',
    selectable: false,
    selectOK: 15,
    img: '/project/finish.jpg',
  },
};
